import React from 'react'
import './Contact.css'
import { MdOutlineEmail } from 'react-icons/md'
import { RiMessengerLine } from 'react-icons/ri'
import { BsWhatsapp } from 'react-icons/bs'
import { useRef } from 'react';
import emailjs from 'emailjs-com'


const Contact = () => {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_onszug5', 'template_mvf2y0b', form.current, 't5HlCnRZZtzAIu6TM')

    e.target.reset()
    
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
  };
  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact_container">
        <div className="contact_options">
          <article className="contact_option">
            <MdOutlineEmail className='contact_option-icon' />
            <h4>Email</h4>
            <h5 className='contact_h5' >yeeshuchauhan94066@gmail.com</h5>
            <a href="mailto:yeeshuchauhan94066@gmail.com" target="_blank" >Send A Mail</a>
          </article>

          <article className="contact_option">
            <RiMessengerLine className='contact_option-icon' />
            <h4>Messenger</h4>
            <h5 className='contact_h5' >Yeeshu Chauhan</h5>
            <a href="https://m.me/yeeshu.chauhan" target="_blank" >Send A Message</a>
          </article>

          <article className="contact_option">
            <BsWhatsapp className='contact_option-icon' />
            <h4>WhatsApp</h4>
            <h5 className='contact_h5' >+91-9575068626</h5>
            <a href="https://api.whatsapp.com/send/?phone=919575068626" target="_blank"  >Connect On WhatsApp</a>
          </article>
        </div>


        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Your Full Name' required />
          <input type="email" name='email' placeholder='Your Email' required />
          <textarea name="message" rows="7" placeholder='Type Your Message' required ></textarea>
          <button onClick={()=>{ alert('Thanks For Your Mail, I Will Get Back To You.... Soon !!!'); }} type='submit' className="btn btn-primary">Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact